import { addPermissionsToRoute } from '@/myq-core/';

const routes = {
  name: 'Product',
  icon: 'mdi-cube-outline',
  path: '/reports/mcd/product/',
  children: [
    {
      path: '/reports/mcd/product/deliveryPrice',
      name: 'Delivery Price Index',
      meta: { id: 'reports-deliveryPricing' },
      component: () => import('./deliveryPriceIndex.vue'),
      ...addPermissionsToRoute(['deliveryPricing']),
    },
    {
      path: '/reports/mcd/product/menuPriceComparison',
      name: 'RFM Price Comparison',
      meta: { id: 'reports-menuPriceComp' },
      component: () => import('./rfm/RFMPriceComparison.vue'),
      ...addPermissionsToRoute(['menuPriceComp']),
    },
    {
      path: '/reports/mcd/product/productMixDrillDown',
      name: 'Product Mix',
      meta: { id: 'reports-pmixCI' },
      component: () => import('./pmixDrillDown/PmixWrapper.vue'),
      ...addPermissionsToRoute(['pmixCI']),
      tags: ['PMIX'],
    },
    {
      path: '/reports/mcd/product/productMixDiscount',
      name: 'PMIX Discount',
      meta: { id: 'reports-pmixDiscountMenuItems' },
      component: () => import('./PMIXDiscount.vue'),
      ...addPermissionsToRoute(['pmixDiscountMenuItems']),
    },
    {
      path: '/reports/mcd/product/productOutage',
      name: 'Reported Product Outage',
      meta: { id: 'reports-productOutage' },
      component: () => import('./productOutage.vue'),
      ...addPermissionsToRoute(['productOutage']),
    },
    {
      path: '/reports/mcd/product/productMixTrend',
      name: 'Product Mix Trend',
      meta: { id: 'reports-productMixTrend' },
      component: () => import('./productMixTrend.vue'),
      ...addPermissionsToRoute(['pmixTrend']),
    },
    {
      path: '/reports/mcd/product/kitchenCapacity',
      name: 'Kitchen Capacity',
      meta: { id: 'reports-kitchenCapacity' },
      component: () => import('./KitchenCapacity.vue'),
      ...addPermissionsToRoute(['reports_access']),
    },
  ],
};

export default routes;
